import script from "./ChangeUserRoleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeUserRoleDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChangeUserRoleDialog.vue?vue&type=style&index=0&id=14d4a9e5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d4a9e5"]])

export default __exports__